import { handleErrors } from '../utils/_handleErrors';

class mCheckoutLoginRegisterGlobale extends HTMLDivElement {
    constructor() {
        super();
        this.guestCustomerForm = document.getElementById('guest-customer'); // First Email Step Form
        this.loginCustomerForm = document.getElementById('registered-customer'); // Second Password Step Form
        // Register Customer Form is initialised by m-ajax-form
        this.guestBtn = document.querySelectorAll('.next-stage-guest'); // Guest Customer Continue Btn
    }

    connectedCallback() {
        this.guestCustomerForm.addEventListener('checkout:nextStage', () => {
            this.showForm(this.guestCustomerForm.action, this.guestCustomerForm);
        });
        this.loginCustomerForm.addEventListener('checkout:nextStage', () => {
            this.sendRegisterForm(this.loginCustomerForm.action, this.loginCustomerForm);
        });
        this.guestBtn.forEach((element) => {
            element.addEventListener('click', () => {
                window.location.href = element.getAttribute('data-href');
            });
        });
    }

    showForm(action, form) {
        fetch(action, {
            method: 'POST',
            body: new FormData(form),
        })
            .then(handleErrors)
            .then((response) => response.json())
            .then((response) => {
                if (!response.success || !response.customer) return;
                const spanEmail = document.querySelectorAll('#login-customerEmail');
                spanEmail.forEach((spanmail) => {
                    spanmail.innerHTML = response.customer.email.value;
                });
                if (response.customer.email.registered === null) {
                    const createUserForm = document.querySelector('#new-customer');
                    this.guestCustomerForm.setAttribute('hidden', true);

                    createUserForm.hidden = false;
                    const inputEmail = document.querySelector('#profile-form-email');
                    inputEmail.value = response.customer.email.value;
                    inputEmail.dispatchEvent(new Event('change'));
                    document.querySelector('.type-email').hidden = true;
                } else {
                    const registeredForm = document.getElementById('registered-customer');
                    this.guestCustomerForm.hidden = true;
                    registeredForm.hidden = false;
                    const inputEmail = document.querySelector('#emailRegistered');
                    inputEmail.value = response.customer.email.value;
                    inputEmail.dispatchEvent(new Event('change'));
                }
            });
    }

    sendRegisterForm(action, form) {
        fetch(action, {
            method: 'POST',
            body: new FormData(form),
        })
            .then(handleErrors)
            .then((response) => response.json())
            .then((response) => {
                if (response.error) {
                    this.loginCustomerForm.setFormMessage('error', response.customerErrorMessage);
                    return;
                }
                if (response.success) {
                    if (response.gtmData) {
                        var gtm = document.querySelector('[is="o-gtm"]');
                        if (response.gtmData && gtm) {
                            gtm.ajaxEvent(response.gtmData);
                        }
                    }

                    this.loginCustomerForm.setFormMessage('success', '');
                    if (response.redirectUrl) {
                        window.location.href = response.redirectUrl;
                    }
                }
            });
    }
}

customElements.define('m-checkout-login-register-globale', mCheckoutLoginRegisterGlobale, {
    extends: 'div',
});
